import React, { useState } from "react";
import { FiList, FiCalendar } from "react-icons/fi";

const ToggleView = ({ onChange }) => {
  const [view, setView] = useState("list");

  const handleToggle = (newView) => {
    setView(newView);
    if (onChange){ 
        onChange(newView); 
    }
    // console.log("view", view);
  };

  return (
    <div className="toggle_container">
      <button
        className={`toggle_btn ${view === "list" ? "toggle_active" : "toggle_inactive"}`}
        onClick={() => handleToggle("list")}
      >
        <FiList size={20} />
      </button>
      <button
        className={`toggle_btn ${view === "calendar" ? "toggle_active" : "toggle_inactive"}`}
        onClick={() => handleToggle("calendar")}
        disabled={true}
      >
        <FiCalendar size={20} />
      </button>
    </div>
  );
};

export default ToggleView;